var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _accountsMap, _partialAccountsMap;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }
function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }
function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { AccountService, ListAccountsRequest } from '@square/dashboard-protos/models/squareup/banking/account_service';
import { AccountType, OwnerType } from '@square/dashboard-protos/models/squareup/banking/common';
import Service, { inject as service } from '@ember/service';
import { computed, set, notifyPropertyChange } from '@ember/object';
import rpc from '@banking/api/utils/rpc';
export const LIST_ACCOUNTS_URL = '/api/v1/banking/list-accounts';
const MAX_LIST_ACCOUNTS_SIZE = 40;
let BankingAccountApi = (_dec = computed('accountsMap'), _dec2 = computed('partialAccountsMap'), _dec3 = computed('capitalEngineContext.headers'), _dec4 = computed('accounts'), _dec5 = computed('accounts'), _dec6 = computed('accounts'), (_class = (_accountsMap = /*#__PURE__*/new WeakMap(), _partialAccountsMap = /*#__PURE__*/new WeakMap(), class BankingAccountApi extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _defineProperty(this, "currentListAccountsRequest", void 0);
    _defineProperty(this, "isLoading", false);
    _classPrivateFieldInitSpec(this, _accountsMap, {
      writable: true,
      value: new Map()
    });
    _classPrivateFieldInitSpec(this, _partialAccountsMap, {
      writable: true,
      value: new Map()
    });
  }
  get accounts() {
    return [..._classPrivateFieldGet(this, _accountsMap).values()].flat();
  }
  get partialAccounts() {
    return [..._classPrivateFieldGet(this, _partialAccountsMap).values()].flat();
  }
  getAccountsForOwner(owner) {
    return _classPrivateFieldGet(this, _accountsMap).get(owner.id) || [];
  }
  getPartialAccountsForOwner(owner) {
    return _classPrivateFieldGet(this, _partialAccountsMap).get(owner.id) || [];
  }
  getAccount(id) {
    return this.accounts.find(account => account.id === id);
  }
  get client() {
    return AccountService.create(rpc((method, guessedUrl) => {
      switch (method) {
        case AccountService.methods.ListAccounts:
          return LIST_ACCOUNTS_URL;
        default:
          return guessedUrl;
      }
    }, new Map(Object.entries(this.capitalEngineContext.headers))));
  }
  get checkingBalances() {
    return this.accounts.filter(account => {
      return account?.owner?.type === OwnerType.UNIT && account.type !== AccountType.SAVINGS_ACCOUNT && account.type !== AccountType.FOLDERS_ACCOUNT;
    });
  }
  get savingsBalances() {
    return this.accounts.filter(account => {
      return account?.owner?.type === OwnerType.MERCHANT && account.type === AccountType.SAVINGS_ACCOUNT;
    });
  }
  get folderBalances() {
    return this.accounts.filter(account => {
      return account?.owner?.type === OwnerType.MERCHANT && account.type === AccountType.FOLDERS_ACCOUNT;
    });
  }
  updateAccountsMaps(accounts, partialAccounts) {
    accounts.forEach(account => {
      if (account.owner) {
        const accountsForOwner = this.getAccountsForOwner(account.owner);
        const ownerAccountIds = accountsForOwner.map(accountForOwner => accountForOwner.id);

        // If we haven't fetched this account yet, add it to the map.
        // Otherwise, remove previously fetched account
        // and replace it with the fresh one.
        if (!ownerAccountIds.includes(account.id)) {
          accountsForOwner.push(account);
        } else {
          const accountIndex = ownerAccountIds.indexOf(account.id);
          accountsForOwner[accountIndex] = account;
        }
        _classPrivateFieldGet(this, _accountsMap).set(account.owner.id, accountsForOwner);
      }
    });
    partialAccounts.forEach(partialAccount => {
      if (partialAccount.owner) {
        const partialAccountsForOwner = _classPrivateFieldGet(this, _partialAccountsMap).get(partialAccount.owner.id);
        if (!partialAccountsForOwner) {
          _classPrivateFieldGet(this, _partialAccountsMap).set(partialAccount.owner.id, [partialAccount]);
        } else {
          const accountIndex = partialAccountsForOwner.findIndex(account => account.id === partialAccount.id);
          if (accountIndex === -1) {
            partialAccountsForOwner.push(partialAccount);
          } else {
            partialAccountsForOwner[accountIndex] = partialAccount;
          }
        }
      }
    });
    notifyPropertyChange(this, 'accountsMap');
    notifyPropertyChange(this, 'partialAccountsMap');
  }
  async fetchAccounts(owners) {
    if (owners.length === 0) {
      return;
    }
    const request = ListAccountsRequest.create({
      owners
    });
    this.currentListAccountsRequest = request;
    set(this, 'isLoading', true);
    try {
      const {
        accounts,
        partialAccounts
      } = await this.client.listAccounts(request);
      this.updateAccountsMaps(accounts, partialAccounts);
    } finally {
      set(this, 'isLoading', false);
    }
  }

  // Ledger's ListPendingBalances has a max size of 100 in the request.
  // 03-26-24: Seeing timeouts when fetching 100 accounts at once. The response
  // was taking ~9s. Reducing the max size to 40 to see if that helps.
  async listAccountsBatch(owners, size = MAX_LIST_ACCOUNTS_SIZE) {
    const ownersBatch = Array.from({
      length: Math.ceil(owners.length / size)
    }, (_element, i) => owners.slice(i * size, i * size + size));
    const accounts = await ownersBatch.reduce(async (prevPromise, owners) => {
      return [...(await prevPromise), ...(await this.listAccounts(owners))];
    }, Promise.resolve([]));
    return accounts;
  }
  async listAccounts(owners,
  // eslint-disable-next-line unicorn/no-object-as-default-parameter
  {
    reload
  } = {
    reload: false
  }) {
    let ownersToFetch;
    if (reload) {
      ownersToFetch = owners;
    } else {
      ownersToFetch = owners.filter(owner => {
        return !_classPrivateFieldGet(this, _accountsMap).has(owner.id);
      });
    }
    await this.fetchAccounts(ownersToFetch);
    let accounts = [];
    owners.forEach(owner => {
      const ownerAccounts = this.getAccountsForOwner(owner);
      accounts = [...accounts, ...ownerAccounts];
    });
    return accounts;
  }
  async reloadAccounts() {
    await this.fetchAccounts(this.currentListAccountsRequest.owners);
  }
  async retrieveAccount(accountId, owners) {
    // See if we've already fetched this account
    const existingAccount = this.getAccount(accountId);
    if (existingAccount) {
      return existingAccount;
    } else {
      await this.listAccounts(owners);
      const fetchedAccount = this.getAccount(accountId);
      if (fetchedAccount) {
        return fetchedAccount;
      } else {
        throw new Error(`Unable to retrieve account ${accountId}`);
      }
    }
  }
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "accounts", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "accounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "partialAccounts", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "partialAccounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "client", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "client"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkingBalances", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "checkingBalances"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "savingsBalances", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "savingsBalances"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "folderBalances", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "folderBalances"), _class.prototype)), _class));
export { BankingAccountApi as default };